import firebase from 'firebase/compat/app';

import STORE_CONSTANTS from './constants';

const converter = {
  toFirestore(item: InsightsFeedback.Doc): firebase.firestore.DocumentData {
    return { ...item };
  },
  fromFirestore(
    snapshot: firebase.firestore.QueryDocumentSnapshot,
    options: firebase.firestore.SnapshotOptions,
  ): InsightsFeedback.Doc {
    return {
      ...(snapshot.data(options) as InsightsFeedback.Doc),
      id: snapshot.id,
    };
  },
};

// Insights feedback / corrections: accounts/{accountId}/insightsFeedback/{id}.
// Staff-read (see firestore.rules); all writes are Admin-SDK only (the
// submit/review Cloud Functions), so this ref is read-only in the client.
const getInsightsFeedbackRef = ({
  accountId,
  db,
}: {
  accountId: string;
  db?: firebase.firestore.Firestore;
}) => {
  return (db ? db : firebase.firestore())
    .collection('accounts')
    .doc(accountId)
    .collection(STORE_CONSTANTS.INSIGHTS_FEEDBACK_COLLECTION)
    .withConverter(converter);
};

export default getInsightsFeedbackRef;
